export default __webpack_public_path__ + "static/home-15d3ed7f06b22973bcd7922e497ef311.png";